module.exports = __webpack_public_path__ + "static/media/footballFansClap.2b99f1fd.jpg";